import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from '@mui/material';
import { useSnackbar } from '@contexts/SnackbarContext';
import API from '@utils/axios';

function CustomerRebalance({ customerId, type, refreshAll }) {
    const { t } = useTranslation();
    const { showMessage } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const handleRebalance = async () => {
        setLoading(true);
        try {
            await API.post(`/customers/${customerId}/rebalance/${type}`);
            showMessage(t('Rebalance successful'), 'success');
        } catch (error) {
            console.error('Error during rebalance:', error);
            if (error.response?.status === 400 && error.response.data?.message) {
                showMessage(t(error.response.data.message), 'error');
            } else {
                showMessage(t('Error during rebalance'), 'error');
            }
        } finally {
            setLoading(false);
            if (refreshAll) {
                refreshAll();
            }
        }
    };

    return (
        <Tooltip title={t('This action resets negative packs to zero by reducing the quantity of positive packs accordingly.')} placement="top" arrow>
            <Button
                variant="contained"
                onClick={handleRebalance}
                disabled={loading}
            >
                {t('Rebalance')}
            </Button>
        </Tooltip>
    );
}

export default CustomerRebalance; 
